import React from 'react';
import { useAppSelector } from '../redux/hooks';
import { useGetRecombeeSearchResultsQuery } from '../redux/api-slice';
import { SearchResult } from '../redux/search-data/search-data-slice';
import Result from './Result';

export default function RecombeeResultsContainer() {
    const { query, searchActive, enableRecombeeResults, recombeeResultsCount } = useAppSelector(
        (state) => state.pageSettings,
    );

    const count = recombeeResultsCount || 3;

    const { data } = useGetRecombeeSearchResultsQuery(
        { query, count },
        { skip: !enableRecombeeResults || !searchActive || !query || query.trim() === '' },
    );

    if (!enableRecombeeResults || !searchActive || !query || query.trim() === '' || !data || data.length === 0) {
        return null;
    }

    return (
        <>
            {data.map((result: SearchResult, index: number) => (
                <Result
                    result={result}
                    id={result.id || `recombee-${index}`}
                    isRecommendation
                    key={`recombee-${result.id || index}`}
                />
            ))}
        </>
    );
}
